module.exports = __webpack_public_path__ + "img/082f4a55461ce37f89b6b74442985385.png";